import { DrawerHandler } from "./DrawerHandler";

export class DrawerListener extends DrawerHandler {
  constructor(readonly trigger: Element, overlay: Element | null) {
    super(overlay);
  }

  listen() {
    this.trigger.addEventListener("click", this.handler.bind(this.trigger, this), false);
  }
}
